import { ErrorMessage, Field } from 'formik'
import './newInput.scss'

const NewInput = ({
  label,
  type,
  placeholder,
  name,
  width,
  fieldClassName,
  value,
  disabled,
  required = false,
  errors,
  maxLength,
  ...props
}) => {
  return (
    <div className='commonForm-input' style={{ width: width || '32%' }}>
      {label ? (
        <label htmlFor=''>
          {label}
          <span>{required ? '*' : ''}</span>
        </label>
      ) : (
        ''
      )}
      <Field
        type={type || 'text'}
        placeholder={placeholder}
        name={name}
        className={fieldClassName}
        disabled={disabled}
        style={{ borderColor: errors != undefined && errors != null && errors[name] ? 'red' : '' }}
        maxLength={maxLength}
        {...(value !== undefined ? { value } : {})}
        {...props}
      />
      <ErrorMessage name={name} component='div' className='error-msg' />
    </div>
  )
}

export default NewInput
